import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { LoadingSpinner } from 'src/components/atoms/LoadingSpinner'
import { Page } from 'src/components/layouts/Page'
import { FeaturedPostsSectionRebrand } from 'src/components/organisms/FeaturedPostsSectionRebrand'
import { NativeTree } from 'src/components/organisms/NativeTree'

import { NotFound } from 'src/pages/404/404'
import { NavigationContext } from 'src/types/account'
import { getSanityImageUrl } from 'src/utils/sanity'
import { trpc } from 'src/utils/trpc'

export const NativeTreePage: NextPage = () => {
  const router = useRouter()

  const { slug } = router.query as { slug: string }

  const { data: species, isLoading } = trpc.useQuery([
    'sanity.getNativeTreeSpeciesBySlug',
    { slug }
  ])

  if (isLoading) {
    return <LoadingSpinner isLoading />
  }

  if (!species) {
    return <NotFound />
  }

  return (
    <Page
      navigationContext={NavigationContext.Public}
      title={species.name}
      metaTitle={`Learn more about the ${species.name} tree and more native trees of New Zealand.`}
      metaDescription={species.description}
      image={getSanityImageUrl(species.image, 1200, 630)}
      showHero={false}
      isFullWidth
    >
      <NativeTree species={species} />
      <div className='pb-30'>
        <FeaturedPostsSectionRebrand
          featuredOn='treeDetailPage'
          heading='News and stories'
        />
      </div>
    </Page>
  )
}
